import { createContext } from 'react';

// userAuth
export const CommonContext = createContext();
    export const LOADER_MESSAGE = 'loader-msg';
    export const PAGINATION_INFO = 'pagination-info';
// userAuth
export const LoginContext = createContext();
    // course
    export const AUTH_LOGIN = 'auth-login';
    export const LOGIN_DETAILS = 'login-details';
    export const LOGIN_ERROR = 'user-error';

// CourseContext
export const CourseContext = createContext();
    // course
    export const COURSE_LIST = 'course-list';
    export const COURSE_DETAILS = 'course-details';

// ModuleContext
export const ModuleContext = createContext();
    // module
    export const MODULE_LIST = 'module-list';
    export const MODULE_DETAILS = 'module-details';

// QuestionContext
export const QuestionContext = createContext();
    // question
    export const QUESTION_LIST = 'question-list';
    export const QUESTION_DETAILS = 'question-details';

// BatchContext
export const BatchContext = createContext();
    // batch
    export const BATCH_LIST = 'batch-list';
    export const BATCH_DETAILS = 'batch-details';

// BatchPartContext
export const BatchPartContext = createContext();
    // batch
    export const BATCHPART_LIST = 'batchpart-list';

// UserContext
export const UserContext = createContext();
    // user
    export const USER_LIST = 'user-list';
    export const USER_DETAILS = 'user-details';
    export const SET_TABLE_FILTERS = 'set-table-filters';

// TrainerContext
export const TrainerContext = createContext();
    // trainer
    export const TRAINER_LIST = 'trainer-list';
    export const TRAINER_DETAILS = 'trainer-details';

    //SalesExecutiveContext
export const SalesExecutiveContext = createContext();
    // salesexecutive
    export const SALESEXECUTIVE_LIST = 'salesexecutive-list';
    export const SALESEXECUTIVE_DETAILS = 'salesexecutive-details';

// DashContext
export const DashContext = createContext();
    // user
    export const TEST_LIST = 'test-list';
    export const FEEDBACKSTATUS = 'feedbackstatus';
    export const FEEDBACKDATA = 'feedbackdata';
    export const QUESTION = 'question';
    export const ANSRESULT = 'ansresult';
    export const TEST_RESULT = 'test-result';
    export const FEEDBACKSALESLIST = 'feedbackSalesList';


// WEBPACK FOOTER //
// ./contexts/constant/ActionTypes.js